export default `
mutation addToMyWishlist($campaign_id: ID!) { 
    addToMyWishlist(campaign_id:$campaign_id){ 
    added
    campaign_id
    }
}
`;